/**
 * ObjectHeader React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// reyct
import React from 'react';
import {connect} from 'react-redux';

// material UI
import {withStyles} from "@material-ui/core";

// material UI components
import Typography from '@material-ui/core/Typography';

// icons
import EditIcon from '@material-ui/icons/Edit';

// application
import {selectObjectTitle} from '../../redux/types/selectors';
import {selectTranslation} from '../../redux/configuration/selectors';


/**
 * ObjectHeader is a React component for showing the title of a single object
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectHeader extends React.Component {

    render() {

        const { classes, typeDefinition } = this.props;
        const name = (typeDefinition && typeDefinition.fields && typeDefinition.fields.name) || "unbekannter Typ";

        return (
            <div>
                <Typography variant="h5" className={classes.objectTitle}>
                    <span className={classes.objectTitleText}>{this.props.objectTitle || <i>Unbenannt</i>}</span>
                    {this.props.modified && <EditIcon className={classes.objectTitleIcon} color="disabled" />}
                </Typography>
                <Typography variant="caption" component="p" className={classes.objectSubTitle}>
                    <i>{name}</i>
                </Typography>
            </div>
        );
    }
}

const styles = {
    objectTitle: {
        margin: "auto",
        textAlign: "center"
    },
    objectTitleText: {
        display: "inline-block",
        overflow: 'hidden',
        whiteSpace: "nowrap",
        textOverflow: 'ellipsis',
        maxWidth: "95%",
        verticalAlign: "text-bottom"
    },
    objectTitleIcon: {
        marginLeft: 12,
        verticalAlign: "baseline"
    },
    objectSubTitle: {
        textAlign: "center",
        marginTop: -5,
        marginBottom: 5 
    },
};

const mapStateToProps = (state, props) => {
    const translate = (value) => selectTranslation(state.configuration, value);
    return {
        typeDefinition: state.types.typeDefinitions[props.objectType],
        objectTitle: selectObjectTitle(state.types, state.editing.objects, props.object, translate)
    }
};

export default connect(mapStateToProps)(withStyles(styles)(ObjectHeader));